import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a low rectangular coffee table (~1.0 x 0.6, top at 0.42):
// oak top on matte-black legs with an oak lower shelf.
const OAK = "#c8975a";
const BLACK = "#2e2e30";

export const coffeeTable = defineModel({
  id: "coffee-table",
  batchId: "modern",
  name: "Coffee table",
  tags: ["modern", "interior", "furniture", "table", "living-room"],
  summary: "A low oak coffee table with matte-black legs.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    return [
      // oak top (top surface at 0.42)
      { geometry: new THREE.BoxGeometry(1.0, 0.04, 0.6), color: OAK, position: [0, 0.4, 0] },
      // matte-black legs
      { geometry: new THREE.BoxGeometry(0.05, 0.38, 0.05), color: BLACK, position: [-0.45, 0.19, 0.25] },
      { geometry: new THREE.BoxGeometry(0.05, 0.38, 0.05), color: BLACK, position: [0.45, 0.19, 0.25] },
      { geometry: new THREE.BoxGeometry(0.05, 0.38, 0.05), color: BLACK, position: [-0.45, 0.19, -0.25] },
      { geometry: new THREE.BoxGeometry(0.05, 0.38, 0.05), color: BLACK, position: [0.45, 0.19, -0.25] },
      // lower shelf
      { geometry: new THREE.BoxGeometry(0.86, 0.03, 0.46), color: OAK, position: [0, 0.14, 0] },
    ];
  },
  animations: [],
});
